import { useState } from 'react';
import { useOtpMutation } from '../../../../store/api-slices';
import { TURNSTILE_ENABLED, TURNSTILE_VERIFICATION_TOKEN_HEADER } from '../../../../components-library/auth/OtpFlow';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const useOtpFlow = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:Login:useOtpFlow' });
  const [requestOtp, otpResult] = useOtpMutation();
  const [loading, setLoading] = useState<boolean>(false);
  const [token, setToken] = useState<string>('');

  const tokenIsValid = (): boolean => {
    if (TURNSTILE_ENABLED && !token) {
      toast.error(t('feedback.token_required'));
      return false;
    }
    return true;
  };

  const send = async (args: Parameters<typeof requestOtp>[0]) => {
    if (!tokenIsValid()) {
      return;
    }
    setLoading(true);
    await requestOtp({
      ...args,
      headers: { [TURNSTILE_VERIFICATION_TOKEN_HEADER]: token },
    });
    setLoading(false);
  };
  const resend = async () => {
    setLoading(true);
    await requestOtp({
      ...otpResult.originalArgs!,
      headers: { [TURNSTILE_VERIFICATION_TOKEN_HEADER]: token },
    });
    setLoading(false);
  };

  return {
    otpResult,
    loading,
    send,
    resend,
    attachToken: setToken,
    hasTurnstile: TURNSTILE_ENABLED,
  };
};

export default useOtpFlow;
